import * as React from 'react';
import { T } from '../../Translations';

const TableHeader: React.FC<{}> = () => (
  <thead>
    <tr>
      <th>
        <T kind="Name" />
      </th>
      <th>
        <T kind="Position" />
      </th>
      <th>
        <T kind="Company" />
      </th>
      <th>
        <T kind="Location" />
      </th>
    </tr>
  </thead>
);

export default TableHeader;
